define('cart/quickEditModal',[
    "common/alertMessage",
    "common/spinner",
    "cart/cartItem",
    "quantitySelector/quantitySelector",
    "productOptions/productOptions",
    "common/formUtils"
],
function (alertMessage, spinner, cartItem, quantitySelector, productOptions, formUtils) {

    var sku;
    var variantSku;

    const modalSelector = "#cart-quick-edit-modal";
    const contentPlaceholderSelector = modalSelector + " .content-placeholder";
    const imageSelector = contentPlaceholderSelector + " .quick-edit-variant-image";
    const productOptionsSelector = contentPlaceholderSelector + " .product-options";
    const spinnerSelector = modalSelector + " .spinner-wrapper";

    function init() {        
        $(modalSelector).on("show.bs.modal", fetchDataForModal);  // fires when modal is shown        
        $(modalSelector).on("hidden.bs.modal", modalOnClose);
    }

    function modalOnClose(event) {       
        if ($(event.target).attr("id") != "cart-quick-edit-modal") {
            $('button[data-bs-target="' + modalSelector + '"][data-product-sku="' + sku + '"][data-variant-sku="' + variantSku + '"]').click();
        }
        $(contentPlaceholderSelector).empty();
    }

    function fetchDataForModal(event) {                
        spinner.show(spinnerSelector);

        var clickedElement = $(event.relatedTarget);
        sku = clickedElement.data("productSku");
        variantSku = clickedElement.data("variantSku");
        var postData = {
            sku: sku,
            variantSku: variantSku,
            quantity: cartItem.getQuantity(clickedElement)
        };
        formUtils.useToken(postData);

        $.ajax({
            type: "POST",
            url: "/customapi/Order/CartQuickEditModal",
            dataType: "json",
            data: postData,
            success: function (data) {
                if (data.status === "OK") {
                    // data processed ok on the back-end, put the generated HTML into the placeholder
                    $(contentPlaceholderSelector).html(data.content);

                    $(contentPlaceholderSelector).find(".modal").each(function (index, element) {                        
                        $(element).on("hidden.bs.modal", modalOnClose);
                    })

                    $(contentPlaceholderSelector).find(".modal").appendTo("body");

                    // subscribe to product options events
                    $(productOptionsSelector).on("variantChanged", displayImage);
                    $(productOptionsSelector).on("updateCart", updateCart);
                    // do the necessary initializations for newly displayed HTML
                    productOptions.init();
                    quantitySelector.init();
                    $(modalSelector).modal('handleUpdate');
                } else {
                    // Something's not right.
                    // Display the error messages (if any).
                    if (data.message) alertMessage.error(data.message);
                }
            },
            error: function (jq, status, errorThrown) {
                alertMessage.error(status + ". " + errorThrown);
            },
            complete: function () {
                spinner.hide(spinnerSelector);
            }
        });
    }

    function updateCart(event) {
        hide();
        cartItem.updateCartFromQuickEditModal(event.detail);
    }

    function hide() {
        $(modalSelector).modal("hide");
    }

    function displayImage(event) {
        $(imageSelector)
            .addClass("opacity-05")
            .attr("src", event.detail.quickEditVariantImageUrl)
            .one("load", function () { $(this).removeClass("opacity-05") });
    }

    return {
        init: init,
        displayImage: displayImage,
        hide: hide
    };
});

